
import { defineComponent } from "vue";

export default defineComponent({
  name: "Card1",
  props: {
    title: String,
    src_image: String,
    content: String,
  },
  components: {},
});
